module.exports = __webpack_public_path__ + "img/logo.49e0377b.png";